module.exports = __webpack_public_path__ + "img/shrines-1024.e0a908cd.jpg";